/* eslint-disable max-len */
import React, { useState, useRef } from 'react';
import { IoClose } from 'react-icons/io5';
import Calendar from 'react-calendar';

import '../../assets/style/calendar.css';
import { ReactComponent as CalendarSvg } from '../../assets/svg/calendar.svg';
import useClickOutsideBox from '../hooks/useClickOutsideBox';
import { formatSimpleDate } from '../../utilities/dateTime';
import clsx from 'clsx';

const DatePicker = ({ onChange, value, className, selectRange=true, calendarInputClassName, calendarTitle="Date Range" }) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const wrapperRef = useRef(null);

  useClickOutsideBox(wrapperRef, () => setShowCalendar(false));

  const handleChange = (val) => {
    onChange(val);
    setShowCalendar(!showCalendar);
  };

  return (
    <div className={`relative flex ${className || ''}`}>
      <p className={clsx(
        "border-1 rounded-md py-2 px-2 text-sm text-gray-700 border-alat-dimGrey hover:border-alat-dark leading-tight w-max max-w-[160px] relative dark:text-white",
        className
      )}>
        {value ? (
          <>
            <span
              className="pr-4 text-gray-700 w-max dark:text-white"
              role="presentation"
              onClick={() => setShowCalendar(!showCalendar)}
            >
              {/* If it is a date range this span will display the date range else it would display the single date value */}

              {
                selectRange ? `${formatSimpleDate(value?.[0])} - ${formatSimpleDate(value?.[1])}` : formatSimpleDate(value)
              }
            </span>
            <IoClose
              onClick={() => onChange(null)}
              className="absolute cursor-pointer top-2.5 right-1 text-base hover:bg-alat-dark hover:text-white dark:bg-alat-nero dark:text-white rounded-full p-1"
            />
          </>
        ) : (
          <span
            className={clsx(
              "flex cursor-pointer text-alat-dimGrey pr-14 w-max relative dark:text-white",
              calendarInputClassName
            )}
            role="presentation"
            onClick={() => setShowCalendar(!showCalendar)}
          >
            <CalendarSvg
              className="absolute cursor-pointer top-0.5 right-1 text-base"
            />
            {calendarTitle}
          </span>
        )}
      </p>
      {showCalendar && (
        <div className="overlay">
          <div className="calendar" ref={wrapperRef}>
            <Calendar
              onChange={handleChange}
              className="calendar dark:bg-alat-nero"
              value={value}
              selectRange={selectRange}
              maxDate={new Date()}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DatePicker;
